<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  h3 {
    margin-bottom: utils.in_rem(16px);
  }
</style>

<script>
  import SettingMultiDropdown from "../../../components/shared/SettingMultiDropdown.svelte";

  export let jobStatusSetting = null;
</script>

{#if jobStatusSetting}
  <section>
    <h3>Job information</h3>
    <SettingMultiDropdown setting={jobStatusSetting} />
  </section>
{/if}
